import { useDispatch, useSelector } from "react-redux";
import { getSingleDeviceUsers } from "../../../../../Api Methods/Api"
import { useState, useEffect } from "react";
import classes from './RuleWizard.module.css'
import BasicTable from "../../../../Table/Table/Table";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";

const SkeletonRows = () => (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px", padding: "8px 0" }}>
        {/* Header */}
        <div style={{ display: "flex", gap: "16px", paddingBottom: "8px", borderBottom: "1px solid #f0f0f0" }}>
            <div className={classes.skeletonBar} style={{ height: "13px", width: "35%" }} />
            <div className={classes.skeletonBar} style={{ height: "13px", width: "35%" }} />
            <div className={classes.skeletonBar} style={{ height: "13px", width: "20%" }} />
        </div>
        {/* Rows */}
        {[...Array(6)].map((_, i) => (
            <div key={i} style={{ display: "flex", gap: "16px", alignItems: "center", padding: "6px 0" }}>
                <div className={classes.skeletonBar} style={{ height: "14px", width: `${30 + (i % 3) * 8}%` }} />
                <div className={classes.skeletonBar} style={{ height: "14px", width: `${28 + (i % 4) * 5}%` }} />
                <div className={classes.skeletonBar} style={{ height: "14px", width: "18%" }} />
            </div>
        ))}
    </div>
);

const ChooseUsers = ({ onConfirm }) => {

    const [users, setUsers] = useState([])
    const [loading, setLoading] = useState(true)
    const [selectedUsers, setSelectedUsers] = useState([])
    const token = useSelector(s => s.auth.token);
    const client = useSelector(s => s.auth.client);
    const apiData = { token, client }
    const SiteUUID = localStorage.getItem("DeviceUUID")
    const dispatch = useDispatch();
    const [pageSize, setPageSize] = useState(20)

    const HandleFetchUsers = async () => {
        try {
            const response = await getSingleDeviceUsers(apiData, SiteUUID, dispatch)
            setUsers(response.data)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        HandleFetchUsers()
    }, [])

    const convertRole = (user) => {
        let newRole = user.role
        switch (user.role) {
            case "manager":
                newRole = "App manager"
            break;
            case "user":
                newRole = "App standard user"
            break;
        }

        if (user.liveViewAccess == 1){
            newRole = "Manager Plus"
        }

        return newRole
    }

    const HandleUserChecked = (userObject) => {
        setSelectedUsers(prevSelectedUsers => {
            const exists = prevSelectedUsers.some(user => user === String(userObject.id))
            if (exists){
                return prevSelectedUsers.filter(user => user !== String(userObject.id))
            } else {
                return [...prevSelectedUsers, String(userObject.id)]
            }
        })
    }

    useEffect(() => {
        console.log(selectedUsers);
    }, [selectedUsers])

    const HandleSetUsers = () => {
        onConfirm(selectedUsers)
    }

    const tablecolumns = [
        {
        header: () => (
            <div className={classes.tableTitleText} title="Click to sort">
                <h3>Name</h3>
            </div>
        ),
        accessorKey: 'fullName',
        cell: (row) => {
            return (
           <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ marginRight: "10px" }}>
                    <Checkbox 
                        onChange={e => HandleUserChecked(row.row.original)} 
                        checked={selectedUsers.some((item) => item === String(row.row.original.id))}
                    />
                </div>
                <div
                    className={classes.tableValueText}
                >
                    {row.row.original.fullName}
                </div>
            </div>
            )
        }
        },
        {
        header: () => (
            <div className={classes.tableTitleText}  title="Click to sort">
                <h3 >Email Address</h3>
            </div>
        ),
        accessorKey: 'email',
        cell: (row) => {
            return (
            <div>
                <p className={classes.tableValueText}>{row.row.original.email}</p>
            </div>
            )
        }
        },
        {
        header: () => (
            <div className={classes.tableTitleText}  title="Click to sort">
                <h3>Role</h3>
            </div>
        ),
        accessorKey: 'role',
        cell: (row) => {
            return (
            <div>
                <p className={classes.tableValueText}>{convertRole(row.row.original)}</p>
            </div>
            )
        }
        },
    ];

    if (loading) return <SkeletonRows />;

    if (!users?.length) return (
        <p style={{ textAlign: "center", color: "#9e9e9e", padding: "40px 0" }}>No users found for this site.</p>
    );

    return (
        <div>
            <BasicTable data={users} columns={tablecolumns} rowClick={false} ShowPagination={true} PageSize={pageSize} setPageSize={setPageSize} paginationOptions={[20, 50, 100]} />
            <br/>
            <div style={{display:"flex", alignItems:"flex-end", flexDirection:"row", width:"100%"}}>
                <Button label="Confirm" icon="pi pi-user" severity="success" onClick={HandleSetUsers}/>
            </div>
            
        </div>
    )
}

export default ChooseUsers;